// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  SessionType,
  SessionAccess,
} from "./types";

export const params = {
  scope: __t.option(__t.string()),
  get sessionType() {
    return SessionType;
  },
  get access() {
    return SessionAccess;
  },
  title: __t.option(__t.string()),
  participantIdentities: __t.array(__t.identity()),
  metadataJson: __t.option(__t.string()),
};
export const returnType = __t.string()